// extracted by mini-css-extract-plugin
module.exports = {"footer":"GlobalFooter_footer_1uGe1","icons":"GlobalFooter_icons_1r4cS","isActive":"GlobalFooter_isActive_15I8N","badge":"GlobalFooter_badge_23vkV"};